import { createContext } from "react";

export const AreaContext = createContext({
  area: {
    id: null,
    unclaimedResourcesVisible: false,
    initialized: false,
    storagePacks: [],
    totalQuotas: 0,
    storageAllocation: 0,
    quotas: {},
    error: null,
    loadAttempt: 1,
    loadMaxAttempts: 1
  },
  setArea: () => {},
  retryArea: () => {},
});